// import { createMuiTheme } from "@material-ui/core";
import { createTheme } from '@material-ui/core/styles';

const charcoal = '#40423F';
const black = '#1B1B1B';
const fossil = '#BEBBBB';

export const lucidTheme = createTheme({
  palette: {
    charcoal,
  },
  typography: {
    fontFamily: ['GTAmerica', '"sans-serif"'].join(','),
    h4: {
      fontSize: '36px',
      lineHeight: '43px',
      color: black,
    },
    h5: {
      fontSize: '22px',
      color: charcoal,
      letterSpacing: '-0.44px',
      fontWeight: 300,
    },
    h6: {
      fontSize: '18px',
      color: black,
      fontWeight: 300,
    },
    body1: {
      color: black,
      lineHeight: '28px',
      letterSpacing: '-0.3px',
    },
    body2: {
      color: charcoal,
      fontWeight: 200,
      lineHeight: '19px',
      letterSpacing: '-0.2px',
    },
  },
  props: {
    MuiLink: {
      underline: 'always',
    },
    MuiRadio: {
      color: 'default',
    },
    MuiDialog: {
      PaperProps: {
        square: true,
      },
    },
    MuiTextField: {
      variant: 'outlined',
    },
    MuiButton: {
      variant: 'outlined',
    },
  },
  overrides: {
    MuiLink: {
      root: {
        color: black,
        cursor: 'pointer',
        textDecoration: 'underline',
        fontSize: '16px',
      },
    },
    MuiRadio: {
      root: {
        '&$checked': {
          color: black,
        },
      },
    },
    MuiDialog: {
      paper: {
        background: '#E4DFD4',
        minWidth: '339px',
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: 'white',
        borderRadius: 0,
      },
      input: {
        border: '1px solid #E4DFD4',
        '$::placeholder': {
          color: fossil,
        },
      },
    },
    MuiButton: {
      outlined: {
        borderRadius: 0,
        border: `1px solid ${black}`,
        textTransform: 'initial',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '28px',
        padding: '20px 40px',
      },
    },
  },
});
